/**
 * Auto-dismiss the past-arrival reminder on the booking detail summary 5 seconds
 * after it appears. Covers server-rendered loads and AJAX-injected reloads
 * (e.g. when update_client.js.erb replaces .booking_summary contents).
 *
 * The picker-toggled instance inside the booking creation form is handled by
 * new_booking_form.js so it can re-show on each date change; this module
 * intentionally skips elements wrapped in .j-past-arrival-notice-wrapper.
 */

if (!(window as any).__pastArrivalNoticeAutoDismissInit) {
  (window as any).__pastArrivalNoticeAutoDismissInit = true;

  const DISMISS_AFTER_MS = 5000;
  const FADE_MS = 400;
  const handled = new WeakSet<Element>();

  const fadeOut = (el: HTMLElement): void => {
    (window as any).jQuery(el).fadeOut(FADE_MS);
  };

  const dismiss = (el: HTMLElement): void => {
    if (handled.has(el)) return;
    if (el.closest(".j-past-arrival-notice-wrapper")) return;
    handled.add(el);
    window.setTimeout(() => fadeOut(el), DISMISS_AFTER_MS);
  };

  const scan = (root: ParentNode): void => {
    root
      .querySelectorAll<HTMLElement>(".j-past-arrival-notice")
      .forEach(dismiss);
  };

  const init = (): void => {
    scan(document);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (
            node.matches?.(".j-past-arrival-notice") &&
            !node.closest(".j-past-arrival-notice-wrapper")
          ) {
            dismiss(node as HTMLElement);
          }
          scan(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}
